import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

const BackNavigation = ({ title, projectName }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  return (
    <div className="flex items-center space-x-4 mb-6">
      <button
        onClick={() => navigate(-1)}
        data-testid="back-button"
        className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-slate-600 hover:text-primary hover:bg-slate-100 rounded-sm transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Back</span>
      </button>
      
      <div className="h-6 w-px bg-slate-300" />
      
      <nav className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm min-w-0">
        <button
          onClick={() => navigate('/projects')}
          className="text-slate-500 hover:text-primary transition-colors flex items-center space-x-1"
        >
          <Home className="w-4 h-4" />
          <span>Projects</span>
        </button>
        
        {projectId && (
          <>
            <span className="text-slate-400">/</span>
            <button
              onClick={() => navigate(`/dashboard/${projectId}`)}
              className="text-slate-500 hover:text-primary transition-colors"
            >
              {projectName || 'Dashboard'}
            </button>
          </>
        )}
        
        {title && (
          <>
            <span className="text-slate-400">/</span>
            <span className="text-primary font-medium">{title}</span>
          </>
        )}
      </nav>
    </div>
  );
};

export default BackNavigation;
